<template>
  <div>
    <div id="userList">
      <div class="search" id="searchSet">
        <div class="p_select">
          <el-date-picker v-model="startDay" type="date" value-format="yyyy-MM-dd" format='yyyy-MM-dd'
            placeholder="选择开始日期">
          </el-date-picker>
        </div>
        <div class="p_select">
          <el-date-picker v-model="endDay" type="date" value-format="yyyy-MM-dd" format='yyyy-MM-dd'
            placeholder="选择结束日期">
          </el-date-picker>
        </div>

        <div class="p_select">
          <el-button type="primary" @click="handleQueryButtonClick(0)" icon="el-icon-search">数据报表</el-button>
          <el-button type="primary" @click="handleQueryButtonClick(1)" icon="el-icon-search">展示图表</el-button>
          <el-button type="warning" @click="downloadDataToExcel" icon="el-icon-download" v-if="showType === 0">导出数据
          </el-button>
        </div>
      </div>
      <el-tabs type="border-card" v-model="activeName" @tab-click="handleTabClick">
        <el-tab-pane label="全店" name="first">
          <el-table id="table_1" v-if="showType === 0" :data="AllOrgDayTrendLineData" border :height=winHeight
            ref="table_1" show-summary>
            <el-table-column prop="checkDay" label="日期"  ></el-table-column>
            <el-table-column prop="inCarCount" label="进站台数" align="left"></el-table-column>
            <el-table-column prop="checkNum" label="检测台数" align="left" sortable></el-table-column>
            <el-table-column prop="faultNum" label="检出台数" align="left" sortable></el-table-column>
            <el-table-column prop="dealNum" label="有成交台数" align="left" sortable></el-table-column>
            <el-table-column prop="itemCheckNum" label="检测项目数" align="left"></el-table-column>
            <el-table-column prop="itemFaultNum" label="检出项目数" align="left" sortable></el-table-column>
            <el-table-column prop="itemDealNum" label="成交项目数" align="left" sortable></el-table-column>
          </el-table>
          <div v-if="showType == 1" type="border-card" style="margin:10px;">
            <div id="chart1" class="ecChart2"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="单项目" name="second">
          <div class="search" style="margin-left:10px">
            <div class="p_select">
              <el-select v-model="positionId" filterable placeholder="请选择部位" @change="onSelectChanged">
                <el-option v-for="item in positionList" :key="item.positionId" :label="item.positionName"
                  :value="item.positionId"></el-option>
              </el-select>
            </div>
          </div>
          <el-table id="table_2" v-if="showType === 0" :data="SinglePositionDayTrendLineData" border :height=winHeight2
            ref="table_2" show-summary>
            <el-table-column prop="checkDay" label="日期" align="left"></el-table-column>
            <el-table-column prop="inCarCount" label="进站台数" align="left"></el-table-column>
            <el-table-column prop="checkNum" label="检测台数" align="left" sortable></el-table-column>
            <el-table-column prop="faultNum" label="检出台数" align="left" sortable></el-table-column>
            <el-table-column prop="dealNum" label="有成交台数" align="left" sortable></el-table-column>
            <el-table-column prop="itemCheckNum" label="检测项目数" align="left"></el-table-column>
            <el-table-column prop="itemFaultNum" label="检出项目数" align="left" sortable></el-table-column>
            <el-table-column prop="itemDealNum" label="成交项目数" align="left" sortable></el-table-column>
          </el-table>
          <div v-if="showType == 1" type="border-card" style="margin:10px;">
            <div id="chart2" class="ecChart2"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="单服务顾问" name="third">
          <div class="search" style="margin-left:10px">
            <div class="p_select">
              <el-select v-model="saId" filterable placeholder="请选择部位" @change="onSelectChanged">
                <el-option v-for="item in orginUserArr" :key="item.saId" :label="item.saName" :value="item.saId">
                </el-option>
              </el-select>
            </div>
          </div>
          <el-table id="table_3" v-if="showType === 0" :data="SinglePositionDayTrendLineData" border :height=winHeight2
            ref="table_3" show-summary>
            <el-table-column prop="checkDay" label="日期" align="left"></el-table-column>
            <el-table-column prop="inCarCount" label="进站台数" align="left"></el-table-column>
            <el-table-column prop="checkNum" label="检测台数" align="left" sortable></el-table-column>
            <el-table-column prop="faultNum" label="检出台数" align="left" sortable></el-table-column>
            <el-table-column prop="dealNum" label="有成交台数" align="left" sortable></el-table-column>
            <el-table-column prop="itemCheckNum" label="检测项目数" align="left"></el-table-column>
            <el-table-column prop="itemFaultNum" label="检出项目数" align="left" sortable></el-table-column>
            <el-table-column prop="itemDealNum" label="成交项目数" align="left" sortable></el-table-column>
          </el-table>
          <div v-if="showType == 1" type="border-card" style="margin:10px;">
            <div id="chart3" class="ecChart2"></div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="单服务顾问&单项目" name="fourth">
          <div class="search" style="margin-left:10px">
            <div class="p_select">
              <el-select v-model="saId" filterable placeholder="请选择部位" @change="onSelectChanged">
                <el-option v-for="item in orginUserArr" :key="item.saId" :label="item.saName" :value="item.saId">
                </el-option>
              </el-select>
            </div>
            <div class="p_select">
              <el-select v-model="positionId" filterable placeholder="请选择部位" @change="onSelectChanged">
                <el-option v-for="item in positionList" :key="item.positionId" :label="item.positionName"
                  :value="item.positionId"></el-option>
              </el-select>
            </div>
          </div>
          <el-table id="table_4" v-if="showType === 0" :data="SinglePositionDayTrendLineData" border :height=winHeight2
            ref="table_4" show-summary>
            <el-table-column prop="checkDay" label="日期" align="left"></el-table-column>
            <el-table-column prop="inCarCount" label="进站台数" align="left"></el-table-column>
            <el-table-column prop="checkNum" label="检测台数" align="left" sortable></el-table-column>
            <el-table-column prop="faultNum" label="检出台数" align="left" sortable></el-table-column>
            <el-table-column prop="dealNum" label="有成交台数" align="left" sortable></el-table-column>
            <el-table-column prop="itemCheckNum" label="检测项目数" align="left"></el-table-column>
            <el-table-column prop="itemFaultNum" label="检出项目数" align="left" sortable></el-table-column>
            <el-table-column prop="itemDealNum" label="成交项目数" align="left" sortable></el-table-column>
          </el-table>
          <div v-if="showType == 1" type="border-card" style="margin:10px;">
            <div id="chart4" class="ecChart2"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import net from "../../assets/js/public";
import BarLine from "../../assets/js/barLineChart";
import * as echarts from 'echarts';
import XLSX from "xlsx";
import FileSaver from "file-saver";

export default {
  data() {
    return {
      tabIndex: 0,
      activeName: 'first',
      orgArr: [],
      orginUserArr: [], // 站点下所有SA
      orgId: '',
      startDay: '',
      endDay: '',
      //新
      winHeight: "200",
      winHeight2: '200',
      positionList: [],
      positionId: 0,
      saId: 0,
      showType: 0,//0报表1图表
      AllOrgDayTrendLineData: [],
      SinglePositionDayTrendLineData: [],

    };
  },
  created() {
    let obj = new Date();
    let month = obj.getMonth() + 1;
    let day = obj.getDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    this.startDay = obj.getFullYear() + "-" + month + "-01";

    let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
    let afterMonth = after.getMonth() + 1;
    if (afterMonth < 10) afterMonth = "0" + afterMonth;
    let afterDay = after.getDate()
    this.endDay = after.getFullYear() + "-" + afterMonth + "-" + afterDay;

    this.getPositionList()
    this.querySaList()
    this.queryDayTrendLineData(this.showType)

  },
  mounted() {

  },
  methods: {
    updateTableHeight(tableId, searchLines) {
      this.winHeight = net.setWindowHeight('searchSet')
      this.winHeight2 = net.setWindowHeight1_1('searchSet')
      this.$nextTick(() => {
        this.$refs[tableId].doLayout();
      })
    },

    // 获取所有部位
    getPositionList() {
      net.request("admin/manage/parts/getPositionList", "post").then(res => {
        if (res.code == 0) {
          this.positionList = res.data
          this.positionId = res.data[0].positionId
        } else {
          net.message(this, "获取数据失败", "warning");
        }
      })
    },
    onOrgChanged() {
      if (this.tabIndex == 0 || this.tabIndex == 1) {
        this.doQueryDataAction()
      } else {
        this.querySaList()
      }
    },
    querySaList() {
      // 选择站点之后再获取SA
      net.request("admin/manage/report/getSAByOrg", "post").then(res => {
        if (res.code === 0) {
          this.orginUserArr = res.data;
          this.saId = res.data[0].saId
          if (this.tabIndex == 2 || this.tabIndex == 3) {
            this.doQueryDataAction()
          }
        } else {
          net.message(this, "获取数据失败", "warning");
        }
      });
    },
    //切换tab
    handleTabClick(e) {
      this.tabIndex = parseInt(e.index)
      this.doQueryDataAction()
      if (this.showType == 0) {
        switch (this.tabIndex) {
          case 0:
            this.updateTableHeight('table_1')
            break
          case 1:
            this.updateTableHeight('table_2')
            break
          case 2:
            this.updateTableHeight('table_3')
            break
          case 3:
            this.updateTableHeight('table_4')
            break
        }
      }
    },
    handleQueryButtonClick(showType) {
      this.showType = parseInt(showType)
      this.doQueryDataAction()
    },
    onSelectChanged() {
      this.doQueryDataAction()
    },
    doQueryDataAction() {
      switch (this.tabIndex) {
        case 0:
          this.queryDayTrendLineData()
          break
        case 1:
          this.queryDayTrendLinePositionData()
          break
        case 2:
          this.queryDayTrendLineSaData()
          break
        case 3:
          this.queryDayTrendLineBothData()
          break
      }
    },
    downloadDataToExcel() {
      var tableId = "#table_1"
      var saveFileName = "全店趋势数据"
      switch (this.tabIndex) {
        case 0:
          tableId = "#table_1"
          saveFileName = "全店趋势数据"
          break
        case 1:
          tableId = "#table_2"
          saveFileName = "单项目趋势数据"
          break
        case 2:
          tableId = "#table_3"
          saveFileName = "单服务顾问趋势数据"
          break
        case 3:
          tableId = "#table_4"
          saveFileName = "单服务顾问单项目趋势数据"
          break
      }
      setTimeout(() => {
        var wb = XLSX.utils.table_to_book(document.querySelector(tableId));
        var wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array"
        });
        try {
          FileSaver.saveAs(
            new Blob([wbout], { type: "application/octet-stream" }),
            saveFileName + ".xlsx"
          );
        } catch (e) {
          if (typeof console !== "undefined") console.log(e, wbout);
          net.message(this, "发生错误,数据导出失败", "warning");
        }
        this.getUnSoldDetail()
      }, 2000);
    },
    queryDayTrendLineData() {
      const params = {
        saId: 0,
        positionId: 0,
        startDay: this.startDay,
        endDay: this.endDay,
      }
      net.request('admin/manage/charts2/queryDayTrendLineData', 'post', params).then(res => {
        if (res.code == 0) {
          if (this.showType == 0) {
            this.AllOrgDayTrendLineData = res.data
            this.updateTableHeight('table_1')
          } else {
            this.setDayTrendLineDataChart(res.data, 'chart1')
          }
        } else {
          net.message(this, res.retmsg, "warning");
        }
      })
    },
    queryDayTrendLinePositionData() {
      const params = {
        saId: 0,
        positionId: this.positionId,
        startDay: this.startDay,
        endDay: this.endDay,
      }
      net.request('admin/manage/charts2/queryDayTrendLineData', 'post', params).then(res => {
        if (res.code == 0) {
          if (this.showType == 0) {
            this.SinglePositionDayTrendLineData = res.data
            this.updateTableHeight('table_2')
          } else {
            this.setDayTrendLineDataChart(res.data, 'chart2');
          }
        } else {
          net.message(this, res.retmsg, "warning");
        }
      })
    },
    queryDayTrendLineSaData() {
      const params = {
        saId: this.saId,
        positionId: 0,
        startDay: this.startDay,
        endDay: this.endDay,
      }
      net.request('admin/manage/charts2/queryDayTrendLineData', 'post', params).then(res => {
        if (res.code == 0) {
          if (this.showType == 0) {
            this.SinglePositionDayTrendLineData = res.data
            this.updateTableHeight('table_3')
          } else {
            this.setDayTrendLineDataChart(res.data, 'chart3');
          }
        } else {
          net.message(this, res.retmsg, "warning");
        }
      })
    },
    queryDayTrendLineBothData() {
      const params = {
        saId: this.saId,
        positionId: this.positionId,
        startDay: this.startDay,
        endDay: this.endDay,
      }
      net.request('admin/manage/charts2/queryDayTrendLineData', 'post', params).then(res => {
        if (res.code == 0) {
          if (this.showType == 0) {
            this.SinglePositionDayTrendLineData = res.data
            this.updateTableHeight('table_4')
          } else {
            this.setDayTrendLineDataChart(res.data, 'chart4');
          }
        } else {
          net.message(this, res.retmsg, "warning");
        }
      })
    },

    setDayTrendLineDataChart(data, domId) {
      const chartDom = document.getElementById(domId);
      const chart = echarts.init(chartDom);
      let legendData = ['进站台次', '检测台次', '检出台次', '成交台次', '检测项目数', '检出项目数', '成交项目数']
      let xAxisData = []
      let yAxisData = []
      for (let i = 0; i < legendData.length; i++) {
        yAxisData[i] = {
          name: legendData[i],
          type: i == 0 ? 'bar' : 'line',
          smooth: true,
          yAxisIndex: i < 4 ? 0 : 1,
          data: []
        }
      }
      let maxCarCount = 0
      let maxItemCount = 0
      for (let i = 0; i < data.length; i++) {
        xAxisData[i] = data[i].checkDay
        yAxisData[0].data[i] = data[i].inCarCount
        yAxisData[1].data[i] = data[i].checkNum
        yAxisData[2].data[i] = data[i].faultNum
        yAxisData[3].data[i] = data[i].dealNum
        yAxisData[4].data[i] = data[i].itemCheckNum
        yAxisData[5].data[i] = data[i].itemFaultNum
        yAxisData[6].data[i] = data[i].itemDealNum
        maxCarCount = Math.max(maxCarCount, data[i].inCarCount)
        maxCarCount = Math.max(maxCarCount, data[i].checkNum)
        maxItemCount = Math.max(maxItemCount, data[i].itemCheckNum)
      }
      maxCarCount = (maxCarCount - maxCarCount % 10) + 10
      maxItemCount = (maxItemCount - maxItemCount % 10) + 10
      chart.setOption(BarLine.getChartOption(legendData, xAxisData, yAxisData, [maxCarCount, maxItemCount]));
    },


  },
};
</script>
<style lang="less" scoped>
#userList {
  display: flex;
  flex-direction: column;

  .search {
    display: flex;
    flex-wrap: wrap;
    padding-bottom: 10px;

    .p_select {
      margin-right: 20px;
      margin-top: 15px;
    }
  }

  .pagination {
    position: relative;
    margin-top: 20px;

    .el-pagination {
      position: absolute;
      left: 0px;
    }

    .number .active {
      background: #009688 !important;
    }
  }

  .ecChart {
    /*width: 45%;*/
    width: calc((100vw - 270px) / 2);
    min-width: 560px;
    float: left;
    height: calc(100vh - 270px);
    /*margin-top: 40px;*/
    margin-bottom: 10px;
  }

  .ecChart2 {
    width: calc(100vw - 270px);
    height: calc(100vh - 270px);
    /*margin-top: 40px;*/
    margin-bottom: 10px;
  }
}
</style>
